import { inject, injectable } from 'inversify';
import IdVerificationRepository from 'src/features/verification/data/IdVerificationRepository';
import { VerificationSession } from 'src/features/verification/data/service/idVerificationService.types';

interface GetIdVerificationStatusUseCaseParams {
  token: string;
}

interface GetIdVerificationStatusUseCaseInterface {
  execute(
    params: GetIdVerificationStatusUseCaseParams
  ): Promise<VerificationSession>;
}

@injectable()
class GetIdVerificationStatusUseCase
  implements GetIdVerificationStatusUseCaseInterface
{
  @inject(IdVerificationRepository)
  private idVerificationRepository!: IdVerificationRepository;

  async execute({
    token,
  }: GetIdVerificationStatusUseCaseParams): Promise<VerificationSession> {
    try {
      const currentSession =
        await this.idVerificationRepository.getSessionStatus({
          accessToken: token,
        });

      return currentSession;
    } catch (error) {
      throw new Error((error as Error).message);
    }
  }
}

export default GetIdVerificationStatusUseCase;
